module.exports = __webpack_public_path__ + "static/media/absolutoComInternet.f4c40bc3.png";